// DrawDownTable.js
import React from 'react';

const DrawDownTable = ({ drawDownData }) => {
  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>Start Range</th>
            <th>End Range</th>
            <th>Drawdown (%)</th>
            <th>Current Portfolio Return</th>
            <th>Drawdown Amount</th>
            <th>Max Portfolio Return</th>
            <th>Previous Portfolio Return</th>
          </tr>
        </thead>
        <tbody>
          {drawDownData ? (
            <tr>
              <td>{drawDownData.startRange}</td>
              <td>{drawDownData.endRange }</td>
              <td>{drawDownData.drawDownInPercentage }</td>
              <td>{drawDownData.currentPortfolioReturn }</td>
              <td>{drawDownData.drawDownAmount }</td>
              <td>{drawDownData.maxPortfolioReturn }</td>
              <td>{drawDownData.prevPortfolioReturn }</td>
            </tr>
          ) : (
            <tr>
              <td colSpan="7">No drawdown data available...</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DrawDownTable;